var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"transform":"rotate(180 15 7.5)","d":"M1.66663 7.12134C2.34102 7.07988 2.64798 7.51687 5.59206 7.31911C8.53614 7.12134 18.5736 7.07989 27.022 6.45127M19.8356 1.97949C21.4534 2.96618 25.1263 5.17779 27.022 5.74863C28.2913 6.13087 29.1923 6.12548 27.022 7.6332C24.8659 9.13105 23.2565 10.7742 20.0232 12.6462","stroke":"currentColor","strokeWidth":"3.33333","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowLeftInline.defaultProps = {"width":"30","height":"15","viewBox":"0 0 30 15","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
